import { useEffect, useState } from "react";

/**
 * @typedef VirtualScrollingResponse
 * @property {Object[]} data The result set
 * @property {number} totalCount The total count of all resources
 */

/**
 * The function used to fetch the virtual scrolling result set.
 * Returns a promise with the results from the request and the total count of
 * all the resources that can be fetched.
 *
 * @callback fetchRequest
 * @returns {Promise<VirtualScrollingResponse>}
 */

/**
 *
 * @param {fetchRequest} fetchData
 * @param {number} page The current page of results that is being requested
 */
export const useVirtualScrolling = ({ fetchData, page }) => {
  const [results, setResults] = useState([]);
  const [hasResults, setHasResults] = useState([]);
  const [count, setCount] = useState(0);
  const [loadingFirstPage, setLoadingFirstPage] = useState(false);
  const [isNextPageLoading, setIsNextPageLoading] = useState(false);
  const [fetchCount, setFetchCount] = useState(0);

  useEffect(() => {
    setIsNextPageLoading(true);
    if (page === 1) {
      setLoadingFirstPage(true);
    }
    fetchData().then(response => {
      if (response.totalCount > 0) {
        setHasResults(true);
      }
      setFetchCount(fetchCount + 1);
      setResults(page === 1 ? response.data : [...results, ...response.data]);
      setCount(response.totalCount);
      setLoadingFirstPage(false);
      setIsNextPageLoading(false);
    });
  }, [fetchData]);

  return {
    results,
    hasNextPage: results.length < count,
    loadingFirstPage,
    isNextPageLoading,
    hasResults,
    fetchCount,
    totalCount: count
  };
};
